import { useRef, useState } from "react";
import Emoji1 from "./Emoji1";
import Emoji2 from "./Emoji2";
import Emoji3 from "./Emoji3";
import Emoji4 from "./Emoji4";
import Emoji5 from "./Emoji5";

function RateYourExperience() {
  const [rating, setRating] = useState(0);
  const textAreaRef = useRef(null);

  function handleSubmit() {
    const experience = textAreaRef.current?.value?.trim();

    console.log("submit rating & experience", rating, experience);
  }

  return (
    <div className="mt-6 p-5 text-[10px] font-custom bg-white rounded-[20px] shadow-[0px_0px_4px_0px_rgba(166,166,166,0.25)]">
      <div className="text-stone-900 text-base font-semibold font-custom leading-none">
        Rate Your Experience!
      </div>
      <div className="flex justify-between items-center mt-5">
        <Emoji1 onClick={() => setRating(1)} selected={rating === 1} />
        <Emoji2 onClick={() => setRating(2)} selected={rating === 2} />
        <Emoji3 onClick={() => setRating(3)} selected={rating === 3} />
        <Emoji4 onClick={() => setRating(4)} selected={rating === 4} />
        <Emoji5 onClick={() => setRating(5)} selected={rating === 5} />
      </div>
      <div className="relative">
        <textarea
          placeholder="Write about your experience."
          className="mt-4 px-4 py-3 text-sm resize-none w-full bg-white rounded-[10px] border border-neutral-200/60"
          rows={3}
          ref={textAreaRef}
        />
        <div className="absolute bottom-2 right-2 text-stone-300 text-[10px] font-medium">
          25 characters
        </div>
      </div>
      <button
        onClick={handleSubmit}
        className="block mx-auto mt-4 px-7 py-2 text-white bg-violet-900 rounded-3xl outline outline-1 outline-offset-[-1px] text-sm font-bold"
      >
        Submit
      </button>
    </div>
  );
}

export default RateYourExperience;
